import { releaseFeatures } from "@/config/releaseFeatures";
import Link from "next/link";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import {
  FaBolt,
  FaDragon,
  FaDiceSix,
  FaIdBadge,
  FaChessBoard,
  FaAward,
  FaChartLine,
  FaPaperPlane,
} from "react-icons/fa";
import {
  ModeIds,
  MODE_ID_PRACTICE_CHESS,
  MODE_ID_PRACTICE_CHESS960,
  MEMBERSHIP_PAGE,
  MEDALS_PAGE,
} from "@chesshotel/constants";
import { BulletIcon } from "@/icons/BulletIcon";
import { useLeagues } from "@/redux/leagues";
import { getModeNameCapitalFirst } from "@/util/util";
import styles from "./Profile.module.css";

export default function ProfileMenu() {
  const { t } = useTranslation("common");
  const { t: authT } = useTranslation("auth");
  const router = useRouter();
  const { hasMedals, hasLastSeason } = useLeagues();
  const achievement = router.pathname.startsWith("/profile/achievements");
  const progress = router.pathname === "/profile/progress";
  const activeMode =
    !achievement && !progress
      ? Number(router.query.modeId) || MEMBERSHIP_PAGE
      : null;
  const modes = [
    [ModeIds.BULLET, BulletIcon],
    [ModeIds.BLITZ, FaBolt],
    [ModeIds.RAPID, FaDragon],
    [ModeIds.CHESS960, FaDiceSix],
    [ModeIds.DAILY, FaPaperPlane],
  ] as const;
  const item = (href: string, label: string, Icon: any, active: boolean) => (
    <Link
      key={href}
      href={href}
      aria-current={active ? "page" : undefined}
      className={`${styles.sidebarItem} ${active ? styles.active : ""}`}
    >
      <span className={styles.icon}>
        <Icon aria-hidden="true" />
      </span>
      <span className={styles.text}>{label}</span>
    </Link>
  );
  return (
    <nav className={styles.sidebar} aria-label={t("Profile")}>
      <div className={styles.menu}>
        {releaseFeatures.profileProgress && item(
          "/profile/progress",
          t("playerProgress.title"),
          FaChartLine,
          progress
        )}
        {releaseFeatures.dailyPractice && item(
          "/profile/achievements",
          t("practiceAchievements.title"),
          FaAward,
          achievement
        )}
        {item(
          `/profile?modeId=${MEMBERSHIP_PAGE}`,
          authT("Membership"),
          FaIdBadge,
          activeMode === MEMBERSHIP_PAGE
        )}
        {(hasMedals || hasLastSeason) &&
          item(
            `/profile?modeId=${MEDALS_PAGE}`,
            t("Medals"),
            FaAward,
            activeMode === MEDALS_PAGE
          )}
        <p className={styles.submenuTitle}>{t("Leagues")}</p>
        {modes.map(([mode, Icon]) =>
          item(
            `/profile?modeId=${mode}`,
            getModeNameCapitalFirst(mode, t),
            Icon,
            activeMode === mode
          )
        )}
        <p className={styles.submenuTitle}>{t("Practice")}</p>
        {item(
          `/profile?modeId=${MODE_ID_PRACTICE_CHESS}`,
          authT("Chess"),
          FaChessBoard,
          activeMode === MODE_ID_PRACTICE_CHESS
        )}
        {item(
          `/profile?modeId=${MODE_ID_PRACTICE_CHESS960}`,
          "Chess960",
          FaDiceSix,
          activeMode === MODE_ID_PRACTICE_CHESS960
        )}
      </div>
    </nav>
  );
}
